/* eslint-disable react/react-in-jsx-scope */
// import { Link } from "react-router"
import { useState, useEffect, useMemo, useCallback } from 'react'
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { Bars3Icon, BellIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { useParams } from "react-router";
// import { useAuth } from "../components/AuthProvider";
import { useCarts, useCartsDispatch } from '../contexts/CartContext';
// import { useUserContext, useUserDispatch } from '../contexts/UserContext';
// import { deCrypt } from "../api/enCrypt";
import { useNavigate } from "react-router";
import axios from 'axios';


const products = [
  {
    id: 1,
    name: 'Cake browny',
    price: 129.50,
    instock: 200,
    href: '#',
    description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
    img:'https://theunlikelybaker.com/wp-content/uploads/2017/10/Chocolate-Chiffon-Cake-Recipe-Feature.jpg',
    date: 'Mar 16, 2020',
    datetime: '2020-03-16',
    category: 'Cakes',
  },
  {
    id: 2,
    name: 'chiffon-cake',
    price: 89.50,
    instock: '159',
    href: '#',
    description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
    img:'https://cookingwithdog.com/wp-content/uploads/2021/03/chiffon-cake-00-1615696212.9265.jpg',
    date: 'Mar 10, 2020',
    datetime: '2020-03-10',
    category: 'Chiffon',
  },
  {
    id: 3,
    name: 'Yellow Bowl Chiffon',
    price: 79,
    instock: 179,
    href: '#',
    description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
    img:'https://assets.epicurious.com/photos/627aaf5f080d9862e3bda7d6/1:1/w_2560%2Cc_limit/PandanChiffon_RECIPE_050522_33403.jpg',
    date: 'Mar 12, 2020',
    datetime: '2020-03-12',
    category: 'Bakery',
  },
  {
    id: 4,
    name: 'Cake browny',
    price: 109,
    instock: 159,
    href: '#',
    description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
    img:'https://www.allrecipes.com/thmb/JaPmyuRaOPDlGkkk0FwLKu2eoSo=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/7892-chiffon-cake-ddmfs-11960-4x3-31cd0f36773640b193318e76a978cc0a.jpg',
    date: 'Mar 16, 2020',
    datetime: '2020-03-16',
    category: 'Cakes',
  },
  {
    id: 5,
    name: 'Chiffon coconut',
    price: 119,
    instock: 159,
    href: '#',
    description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
    img:'https://zhangcatherine.com/wp-content/uploads/2022/03/12001200.jpg',
    date: 'Mar 10, 2020',
    datetime: '2020-03-10',
    category: 'Chiffon',
  },
  {
    id: 6,
    name: 'Citrus-Chiffon',
    price: 129,
    instock: 179,
    href: '#',
    description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
    img:'https://bakefromscratch.com/wp-content/uploads/2022/05/Citrus-Chiffon-312JBweb.jpg',
    date: 'Mar 12, 2020',
    datetime: '2020-03-12',
    category: 'Bakery',
  },
  {
    id: 7,
    name: 'blueberry-chiffon-cake',
    price: 159,
    instock: 200,
    href: '#',
    description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
    img:'https://teakandthyme.com/wp-content/uploads/2024/10/blueberry-chiffon-cake-DSC_2632-1x1-1200.jpg',
    date: 'Mar 16, 2020',
    datetime: '2020-03-16',
    category: 'Cakes',
  },
  {
    id: 8,
    name: 'browny Choce',
    price: 179,
    instock: 200,
    href: '#',
    description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
    img:'https://www.tasteofhome.com/wp-content/uploads/2018/01/exps164_MC163887B03_10_24b.jpg',
    date: 'Mar 10, 2020',
    datetime: '2020-03-10',
    category: 'Chiffon',
  },
  {
    id: 9,
    name: 'Box4-Chiffon',
    price: 179,
    instock: 200,
    href: '#',
    description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
    img:'https://down-id.img.susercontent.com/file/709385c8df2fb4c8ee3050dc4ba84c52',
    date: 'Mar 12, 2020',
    datetime: '2020-03-12',
    category: 'Bakery',
  },
  {
    id: 10,
    name: 'BirthDay-chiffon-cake',
    price: 159,
    instock: 200,
    href: '#',
    description:'Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.',
    img:'https://down-id.img.susercontent.com/file/dcb34b2ef6fd04941a85432da9dd6d11',
    date: 'Mar 16, 2020',
    datetime: '2020-03-16',
    category: 'Cakes',
  },
  {
    id: 11,
    name: 'Coffee Mocha',
    price: 179,
    instock: 200,
    href: '#',
    description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
    img:'https://images.tokopedia.net/img/cache/500-square/VqbcmM/2021/3/18/ef0914b3-1016-474f-8829-ca599832d4d5.jpg',
    date: 'Mar 10, 2020',
    datetime: '2020-03-10',
    category: 'Chiffon',
  },
  {
    id: 12,
    name: 'Matcha-Chiffon',
    price: 179,
    instock: 200,
    href: '#',
    description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
    img:'https://www.siftandsimmer.com/wp-content/uploads/2022/10/matcha-chiffon-cake-featured.jpg',
    date: 'Mar 12, 2020',
    datetime: '2020-03-12',
    category: 'Bakery',
  },
  {
  id: 13,
    name: 'Chocolate Icing',
    price: 179,
    instock: 200,
    href: '#',
    description:'Optio cum necessitatibus dolor voluptatum provident commodi et. Qui aperiam fugiat nemo cumque.',
    img:'https://www.pholfoodmafia.com/wp-content/uploads/2018/05/1000x650ChocolateChiffonCakewithChocolateIcing-590x418.jpg',
    date: 'Mar 10, 2020',
    datetime: '2020-03-10',
    category: 'Chiffon',
  },
  {
    id: 14,
    name: 'fruit-Chiffon',
    price: 179,
    instock: 200,
    href: '#',
    description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
    img:'https://www.deliciousmagazine.co.uk/wp-content/uploads/2023/04/S2023D103_SEO_CHIFFON_3__-768x960.jpg',
    date: 'Mar 12, 2020',
    datetime: '2020-03-12',
    category: 'Bakery',
  },
  {
    id: 15,
    name: 'Coconut Chiff',
    price: 179,
    instock: 200,
    href: '#',
    description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
    img:'https://www.marthastewart.com/thmb/5Gd1v4aTAfMoBsG-OFGjer7SbmI=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/coconut-chiffon-cake-with-chocolate-frosting-102881873_horiz-6375bc36fd9c4ea587b1bfab1ed2a739.jpgitokjIv4LmSM',
    date: 'Mar 12, 2020',
    datetime: '2020-03-12',
    category: 'Bakery',
  },
  {
    id: 16,
    name: 'Lemon Meringue',
    price: 179,
    instock: 200,
    href: '#',
    description:'Cupiditate maiores ullam eveniet adipisci in doloribus nulla minus. Voluptas iusto libero adipisci rem et corporis. Nostrud sint anim sunt aliqua. Nulla eu labore irure incididunt...',
    img:'https://domesticdreamboat.com/wp-content/uploads/2022/04/Lemon-Meringue-Chiffon-Cake-Cut-cropped.jpg',
    date: 'Mar 12, 2020',
    datetime: '2020-03-12',
    category: 'Bakery',
  },
  // More posts...
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const user = {
  name: 'Tom Cook',
  email: 'tom@example.com',
  imageUrl:
    'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
}
const navigation = [
  { name: 'Home', href: '#', current: false },
  { name: 'Billing', href: '#', current: false },
  { name: 'All Products', href: '#', current: true },
  { name: 'Cakes', href: '#', current: false },
  { name: 'Chiffon', href: '#', current: false },
  { name: 'Bakery', href: '#', current: false },
]
const userNavigation = [
  { name: 'Your Profile', href: '#' },
  { name: 'Settings', href: 'updateuser' },
]



function Products() {
  const carts = useCarts();
  // const userCon = useUserContext();
  const [data, setData] = useState([])

  // const auth = useAuth();
  const navigate = useNavigate();

  const apiurl = `${process.env.REACT_APP_API}/products.php`
  const imgurl = `${process.env.REACT_APP_URL}/image/products`


  // const cartQty = useCartsQty();
  const dispatch = useCartsDispatch();

  const fetchProducts = async () => {
      try {
        const result = await axios.get(`${apiurl}?mode=getactive`);
        
        // console.log(result);
        // console.log(result.data);
        // if(result.data.length>0) {
        if(result.data && result.data[0].length>0) {  
          // const data = await response.json();
          // console.log(result.data[0]);
          setData(result.data[0]);
          return result.data[0];
        }

      }
      catch(err) {
          console.log(err);
        }
      }



  useEffect(() => {

    // fetchProducts();

  },[])



  let { id } = useParams();
  let prods = products;
  // let prods = data;

  if(typeof(id) != "undefined") {
    //  prods = data?.filter( i => i.category===id)
    prods = products?.filter( i => i.category===id)
  } 
  // console.log(currentUser);
  // console.log(cu['email']);

  // console.log(id)
  const setCart = async (pd) => {
    // console.log(pd)

    const cartitem = carts.filter((cart) => cart.pdid === pd.id);
    if (cartitem && cartitem.length > 0) {
      dispatch({
        type: 'changed',
        // id: pd.id,
        pdid: pd.id,
        name: pd.name,
        // discount: 0,
        price: pd.price,
        quantity: 1,
        imageSrc: pd.img,

      });
      
    } else {
      dispatch({
        type: 'added',
        id: pd.id,
        pdid: pd.id,
        name: pd.name,
        // discount: 0,
        price: pd.price,
        quantity: 1,
        imageSrc: pd.img,

      });
    };

    // const response = await axios.get(`/carts?productId=${product.id}`);
    // if (response.data && response.data.length > 0) {
    //   // update cart
    //   const orderItem = response.data[0];
    //   orderItem.qty = parseInt(orderItem.qty) + 1;
    //   orderItem.totalPrice =
    //     parseInt(orderItem.price) * parseInt(orderItem.qty);
    //   dispatch(updateCart(orderItem));
    // } else {
    //   // insert cart
    //   const orderItem = {
    //     qty: 1,
    //     price: product.price,
    //     name: product.name,
    //     totalPrice: product.price,
    //     note: "",
    //     productId: product.id,
    //   };
    //   dispatch(inputCart(orderItem));
    // }
  };

  // const handleLogout = () => {
  //   //
  //   dispatch({
  //       type: 'logout',
  //     });

      // navigate("/");    
  // }


  //   {  if (!cu) {
  //     navigate("/");
  //     return;
  //   }
  // }

  return (
    <div className="py-2 sm:py-1">
          <div className="mx-auto  px-1 md:px-2">
            <div className="overflow-y-auto h-[calc(100vh-35vh)] sm:h-[calc(100vh-160px)] mx-auto grid max-w-2xl grid-cols-3 gap-x-2 gap-y-6 border-t border-gray-200 p-4 sm:mt-4  md:mx-0 md:max-w-none sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-7">
              {prods.map((prod) => (
                <div key={prod.id} className="flex max-w-xl flex-col ">
                    <div className="flex p-0 hover:border-orange-500 hover:border-2 hover:rounded-md hover:cursor-crosshair">
                      <img alt="" className="w-full aspect-square rounded-md bg-gray-50"
                          // src={`${imgurl}/${prod.img}`}
                          src={`${prod.img}`}
                          // onClick={prod => handleClick(prod.id)}
                          onClick={() => setCart(prod)}
                      />
                    </div>
                  <div className="flex w-full rounded-lg items-center justify-between  text-xs pt-2">
                    <p
                      // href={prod.category}
                      className="relative z-10  px-3 py-1.5 font-medium"
                    >
                      {prod.name}
                    </p>
                    <p className="relative z-10 rounded-full bg-gray-300 px-3 py-1.5 font-medium text-gray-700 hover:bg-gray-100">
                        {prod.price}฿
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
  )
}

export default Products